/** 公司信息 — 均来自现有网站内容，请勿随意修改 */
export const COMPANY = {
  name: '广东中泉环保科技有限公司',
  shortName: '中泉环保科技',
  address: '广东省东莞市高埗镇保安围一村高州贝街2号',
  contact: '周先生',
  phone: '13929467632',
  contacts: [
    { name: '周先生', phone: '13929467632' },
    { name: '贺小姐', phone: '18075142966' }
  ],
  icp: '粤ICP备2023101216号',
  icpUrl: 'https://beian.miit.gov.cn/',
  mapUrl: 'https://api.map.baidu.com/marker?location=23.098819,113.702522&title=广东中泉环保科技有限公司&content=广东省东莞市高埗镇保安围一村高州贝街2号&output=html&coord_type=bd09ll&zoom=15&src=webapp.gdzq.website',
  motto: '以诚为本、以质取信、以品生存',
  certification: '一站式环保设备源头厂家'
}

export const HERO_SLIDES = [
  { img: require('@/assets/photos/hero-1.jpg'), title: '中泉环保', subtitle: '专业环保设备设计、生产、维护' },
  { img: require('@/assets/photos/hero-2.jpg'), title: '中泉环保', subtitle: '废气治理 · 除尘净化 · 一站式配套' },
  { img: require('@/assets/photos/hero-3.jpg'), title: '中泉环保', subtitle: '不锈钢环保设备 · 精湛工艺' },
  { img: require('@/assets/photos/hero-4.jpg'), title: '中泉环保', subtitle: '设计 · 生产 · 维护 一体化服务' },
  { img: require('@/assets/photos/hero-5.jpg'), title: '中泉环保', subtitle: COMPANY.certification }
]

export const FACTORY_PHOTOS = [
  { img: require('@/assets/photos/hero-6.jpg'), alt: '环保设备生产车间' },
  { img: require('@/assets/photos/hero-7.jpg'), alt: '不锈钢设备组装' },
  { img: require('@/assets/photos/hero-8.jpg'), alt: '工厂设备展示' },
  { img: require('@/assets/photos/hero-9.jpg'), alt: '成品设备出厂' }
]

export const HIGHLIGHTS = [
  { label: COMPANY.certification },
  { label: '环保设备设计 · 生产 · 维护' },
  { label: '一站式配套服务' }
]
